module.exports = __webpack_public_path__ + "img/walmart.d760fa5c.png";